import { useState } from 'react';
import { api } from '../api';
import { CreateOrganisationData } from '../api/profile';

interface CreateCompanyOptions {
  profileId?: number;
  contactPersonName?: string;
  emailId?: string;
}

export const useAccountSetup = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createCompany = async (data: CreateOrganisationData, options?: CreateCompanyOptions) => {
    setIsLoading(true);
    setError(null);

    try {
      data.contactpersonname = options?.contactPersonName || '';
      data.emailid = options?.emailId || '';

      const organisationResponse = await api.profiles.createOrganisation(data);

      if (organisationResponse.data?.accessToken && organisationResponse.data?.refreshToken) {
        // Both tokens are scoped to the newly created workgroup — persist
        // both (not just the access token), the same way switchWorkgroup
        // does. Keeping the old refresh token here would silently revert
        // the session back to the previous workgroup on the next refresh.
        localStorage.setItem('token', organisationResponse.data.accessToken);
        api.auth.setTokens({
          accessToken: organisationResponse.data.accessToken,
          refreshToken: organisationResponse.data.refreshToken,
        });
      }

      return {
        success: true,
        organisation: organisationResponse.data,
      };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to create company';
      setError(errorMessage);
      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      setIsLoading(false);
    }
  };

  const getPackages = async () => {
    try {
      const response = await api.billing.getPackages();
      return response.data || [];
    } catch (err) {
      return [];
    }
  };

  return {
    createCompany,
    getPackages,
    isLoading,
    error,
  };
};
